<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import Vue from 'vue';
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/partners/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/partners/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Заказы',
                        url: `/partners/${this.$route.params.id}/orders`
                    },
                    {
                        title: 'Отчеты',
                        url: `/partners/${this.$route.params.id}/reports`
                    },
                    {
                        title: 'Скидочные карты',
                        url: `/partners/${this.$route.params.id}/discount-cards`
                    },
                    {
                        title: 'Рестораны',
                        url: `/partners/${this.$route.params.id}/restaurants`
                    },
                    {
                        title: 'Магазины',
                        url: `/partners/${this.$route.params.id}/grocers`
                    },
                    {
                        title: 'Аптеки',
                        url: `/partners/${this.$route.params.id}/pharmacy`
                    },
                    {
                        title: 'Помощники',
                        url: `/partners/${this.$route.params.id}/assistants`
                    },
                ]
            }
        },

        async mounted() {
            const response = await Vue.axios.get('/entities-type/');
            response.data.forEach(entity => {
                const route = {
                    title: entity.title,
                    url: `/partners/${this.$route.params.id}/${entity.code}`,
                };
                this.list.push(route);
            });
        }
    }
</script>
